import { render } from "./TextFieldObservationComponent.vue?vue&type=template&id=23a4e721&ts=true"
import script from "./TextFieldObservationComponent.vue?vue&type=script&lang=ts"
export * from "./TextFieldObservationComponent.vue?vue&type=script&lang=ts"

import "./TextFieldObservationComponent.vue?vue&type=style&index=0&id=23a4e721&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__